<script lang="ts">
  import { page } from "$app/stores"
  import { getStatefulDialog } from "./dialog-utils"

  let { Component, props } = $derived(getStatefulDialog($page.state))
</script>

<Component {...props} open />
